module.exports = __webpack_public_path__ + "img/gh (8).fce4afc0.png";